import { render, staticRenderFns } from "./PaperList.vue?vue&type=template&id=5b57632e&scoped=true"
import script from "./PaperList.vue?vue&type=script&lang=js"
export * from "./PaperList.vue?vue&type=script&lang=js"
import style0 from "./PaperList.vue?vue&type=style&index=0&id=5b57632e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b57632e",
  null
  
)

export default component.exports